import React, { FC } from 'react';
import { Switch } from '@mui/material';
import BedtimeIcon from '@mui/icons-material/Bedtime';
import SunnyIcon from '@mui/icons-material/Sunny';

interface Props {
    onToggleDarkMode: () => void;
    toggleDarkMode: boolean;
}

export const ModeSwitch: FC<Props> = ({ onToggleDarkMode, toggleDarkMode }) => {
    return (
        <>
            <SunnyIcon style={{ height: '20px' }} />
            <Switch checked={!toggleDarkMode} onChange={onToggleDarkMode} />
            <BedtimeIcon style={{ height: '20px' }} />
        </>
    );
};
